<template>
  <div class="footer">
    <div class="detail-footer">
      <img
        :src="'/static/pictures/conference-header-white.svg'"
        class="conference-header"
        alt=""
      />
      <div class="address">
        <span>1010 อาคาร ชินวัตร 3 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร
        กรุงเทพมหานคร 10900 </span>
        <div class="mt-2">
          Tel:1749 Fax:0-2949-2227
        </div>
      </div>
      <div>
      </div>
      <div class="footer-icon mt-4">
        <!-- <img :src="'/static/icons/link-icon.svg'" alt="" class="link-icon"/>
        <img :src="'/static/icons/location-white-icon.svg'" alt="" /> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../css/otherWebVariables";

.footer {
  height: 342px;
  width: 100%;
  background-color: $color-orange;
  color: white;
}

.detail-footer {
  padding-left: 10%;
  padding-top: 5%;
  text-align: left;
}

.address {
  padding-top: 10px;
  width: 350px;
}

.footer-icon,
.conference-header {
  width: 25%;
}

.link-icon {
  padding-right: 20px;
}

@media screen and (max-width: $m-size) {
  .footer {
    height: 300px;
  }

  .detail-footer {
    padding-left: 10%;
    padding-top: 10%;
    text-align: left;
  }

  .address {
    padding-top: 10px;
    width: 80%;
    font-size: $font-14;
  }

  .footer-icon,
  .conference-header {
    width: 50%;
  }
}
</style>
